import { render, staticRenderFns } from "./korean-general.vue?vue&type=template&id=3ebd0373&scoped=true&"
import script from "./korean-general.vue?vue&type=script&lang=js&"
export * from "./korean-general.vue?vue&type=script&lang=js&"
import style0 from "./korean-general.vue?vue&type=style&index=0&id=3ebd0373&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ebd0373",
  null
  
)

export default component.exports